import { createBaseFeed } from "../../factory/core/createBaseFeed.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/theme";
import "@universityofmaryland/web-elements-library";
import "@universityofmaryland/web-elements-library/composite";
import "@universityofmaryland/web-elements-library/atomic";
import "@universityofmaryland/web-utilities-library/elements";
import "@universityofmaryland/web-utilities-library/network";
import { newsDisplayStrategy } from "../../strategies/display/news.js";
import "../../strategies/fetch/events.js";
import { newsFetchStrategy } from "../../strategies/fetch/news.js";
import "../../strategies/fetch/experts.js";
import "../../strategies/fetch/inTheNews.js";
import { stackedLayout } from "../../strategies/layout/grid.js";
import "@universityofmaryland/web-elements-library/layout";
const newsList = (props) => createBaseFeed({
  ...props,
  cardType: "list",
  isAligned: false,
  fetchStrategy: newsFetchStrategy,
  displayStrategy: newsDisplayStrategy,
  layoutStrategy: stackedLayout,
  imageConfig: (entry) => {
    const imageUrl = entry.image?.[0]?.url;
    const altText = entry.image?.[0]?.altText;
    if (!imageUrl || !altText) {
      return null;
    }
    return {
      imageUrl,
      altText,
      linkUrl: entry.url,
      linkLabel: "Maryland Today Article with image"
    };
  }
});
export {
  newsList
};
//# sourceMappingURL=list.js.map
